import { useEffect, useState } from 'react';
import { formatNumber, noContent } from '../../utils/propertyDetailsMapper';
import LineDivider from '../LineDivider';
import Loading from '../Loading';
import NoContent from '../NoContent';
import Service from '../../Service';

function PropertyDetails(props) {
	const { address } = props;
	const service = new Service();
	const [details, setDetails] = useState(null);
	const [error, setError] = useState(null);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		getPropertyDetails();
	}, []);

	async function getPropertyDetails() {
		try {
			const response = await service.getPropertyDetails(address);
			setDetails(response.property.details);
			props.handlePropertyImage(response.property.details.image_url);
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			setError('A unexpected error has occurred');
		}
	}

	function renderDetails() {
		if (!details) {
			return (
				<NoContent
					message="There currently is no data from your property to provide you with details."
					title="No Data"
				/>
			);
		}

		return (
			<div className="md:flex justify-between items-center">
				<div className="grid grid-cols-1 gap-4">
					<div className="grid grid-cols-2 gap-12">
						<p className="font-bold whitespace-nowrap">
							Year Built:
						</p>
						<p className="whitespace-nowrap">
							{details.year_built || noContent}
						</p>
					</div>

					<div className="grid grid-cols-2 gap-12">
						<p className="font-bold">Stories:</p>
						<p className="whitespace-nowrap">
							{formatNumber(details.no_of_stories)}
						</p>
					</div>

					<div className="grid grid-cols-2 gap-12">
						<p className="font-bold">Beds:</p>
						<p className="whitespace-nowrap">
							{formatNumber(details.number_of_bedrooms)}
						</p>
					</div>

					<div className="grid grid-cols-2 gap-12">
						<p className="font-bold whitespace-nowrap">
							Full Baths:
						</p>
						<p className="whitespace-nowrap">
							{formatNumber(details.number_of_baths)}
						</p>
					</div>

					<div className="grid grid-cols-2 gap-12">
						<p className="font-bold whitespace-nowrap">
							Half Baths:
						</p>
						<p className="whitespace-nowrap">
							{formatNumber(details.number_of_partial_baths)}
						</p>
					</div>
				</div>
				<LineDivider />
				<div className="grid grid-cols-1 gap-4">
					<div className="grid grid-cols-2 gap-12">
						<p className="font-bold whitespace-nowrap">
							Other Rooms:
						</p>
						<p className="whitespace-nowrap">
							{formatNumber(details.other_rooms)}
						</p>
					</div>

					<div className="grid grid-cols-2 gap-12">
						<p className="font-bold">Basement:</p>
						<p className="whitespace-nowrap">
							{details.basement || noContent}
						</p>
					</div>

					<div className="grid grid-cols-2 gap-12">
						<p className="font-bold whitespace-nowrap">
							Total Rooms:
						</p>
						<p className="whitespace-nowrap">
							{formatNumber(details.total_number_of_rooms)}
						</p>
					</div>

					<div className="grid grid-cols-2 gap-12">
						<p className="font-bold whitespace-nowrap">Sq Ft.:</p>
						<p className="whitespace-nowrap">
							{formatNumber(details.lot_size_square_feet)}
						</p>
					</div>

					<div className="grid grid-cols-2 gap-12">
						<p className="font-bold whitespace-nowrap">Lot Size:</p>
						<p className="whitespace-nowrap">
							{formatNumber(details.lot_size_acres)}
						</p>
					</div>
				</div>
				<LineDivider />
				<div className="grid grid-cols-1 gap-4">
					<div className="grid grid-cols-2 gap-12">
						<p className="font-bold">Heating:</p>
						<p className="whitespace-nowrap">
							{details.heating.heating || noContent}
						</p>
					</div>

					<div className="grid grid-cols-2 gap-12">
						<p className="font-bold whitespace-nowrap">
							Heating Fuel:
						</p>
						<p className="whitespace-nowrap">
							{details.heating.heating_fuel_type || noContent}
						</p>
					</div>

					<div className="grid grid-cols-2 gap-12">
						<p className="font-bold whitespace-nowrap">
							Garage Type:
						</p>
						<p className="whitespace-nowrap">
							{details.garage_type || noContent}
						</p>
					</div>

					<div className="grid grid-cols-2 gap-12">
						<p className="font-bold whitespace-nowrap">
							Garage Cars:
						</p>
						<p className="whitespace-nowrap">
							{formatNumber(details.garage_cars)}
						</p>
					</div>

					<div className="grid grid-cols-2 gap-12">
						<p className="font-bold">Construction:</p>
						<p className="whitespace-nowrap">
							{details.type_construction || noContent}
						</p>
					</div>
				</div>
			</div>
		);
	}

	if (isLoading) {
		return <Loading />;
	}

	return <section className="my-6 p-5">{renderDetails()}</section>;
}

export default PropertyDetails;
